import { RaThemeOptions, defaultTheme } from 'react-admin';

import openSansBold from '../fonts/OpenSans-Bold.ttf';
import openSansRegular from '../fonts/OpenSans-Regular.ttf';

const theme: RaThemeOptions = {
  ...defaultTheme,
  typography: {
    fontFamily: ['OpenSans Regular', 'Arial', 'sans-serif'].join(','),
    fontSize: 14,
    body1: {
      fontFamily: 'OpenSans Regular, Arial',
      fontSize: 14,
    },
    body2: {
      fontFamily: 'OpenSans Bold, Arial',
      fontSize: 12,
    },
    h3: {
      fontFamily: 'OpenSans Bold, Arial',
      fontSize: 24,
    },
  },
  palette: {
    text: {
      primary: '#2d3748',
    },
    primary: {
      main: '#B484FF',
      contrastText: '#fff',
    },
    secondary: {
      main: '#522296',
      contrastText: '#fff',
    },
  },
  components: {
    ...defaultTheme.components,
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'OpenSans Regular';
          src: local('OpenSans-Regular'),
          url(${openSansRegular}) format('truetype');
        }
        @font-face {
          font-family: 'OpenSans Bold';
          src: local('OpenSans-Bold'),
          url(${openSansBold}) format('truetype');
        }
      `,
    },
  },
};

export default theme;
